<template>
  <div id="app">
    <keep-alive :include="includes">
    <router-view/>
    </keep-alive>
    <BackTop :height="20"></BackTop>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'App',
  data() {
    return {
      scrollTop: null
    }
  },
  beforeCreate() {
    if (/Android|webOS|iPhone|ipad|iPod|BlackBerry/i.test(navigator.userAgent)) {
      window.location.href = 'http://qingfeng.didiglobal.com/index-app.html'
    }
    var whdef = 100 / 1920 // 表示1920的设计图,使用100PX的默认值
    var wH = window.innerHeight // 当前窗口的高度
    var wW = window.innerWidth // 当前窗口的宽度
    var rem = wW * whdef // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
    var fontSize = rem < 80 ? 80 : rem > 100 ? 100 : rem
    document.documentElement.style.fontSize = fontSize + 'px'
    window.onresize = function () {
      var whdef = 100 / 1920 // 表示1920的设计图,使用100PX的默认值
      var wH = window.innerHeight // 当前窗口的高度
      var wW = window.innerWidth // 当前窗口的宽度
      var rem = wW * whdef // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值

      var fontSize = rem < 80 ? 80 : rem > 100 ? 100 : rem
      document.documentElement.style.fontSize = fontSize + 'px'
    }
  },
  computed: mapState(['includes']),
}
</script>


// WEBPACK FOOTER //
// src/App.vue